<template>
  <v-container fluid fill-height>
    <v-toolbar color="white" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>  
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5 text-xs-center>
        <h1 class="display-2 txterror">Whoops, 404</h1>
        <p>The page you were looking for does not exist</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { webUrl } from '@/common/index'
import { mapGetters } from 'vuex';
export default {
	name: "NotFoundPage",
  	components: {},
  	computed: {
    	...mapGetters(['webUrl'])
  	}
};
</script>
<style scoped>
.txterror {
	color: #2d68bd;
}
</style>